(function () {
  if (!window.location.pathname.endsWith('/collections/panel-liners')) {
    return;
  }

  const grid = document.getElementById('product-grid');
  if (!grid) {
    return;
  }

  const items = grid.querySelectorAll('.grid__item[data-ovs-panel-liner-kind]');
  const pagination = document.querySelector('.pagination-wrapper');

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function selectedFromInputs(selector, dataAttr) {
    return [...document.querySelectorAll(selector)]
      .filter((input) => input.checked)
      .map((input) => input.dataset[dataAttr] || '')
      .filter((value) => value !== '');
  }

  function selectedWithUrlFallback(inputSelector, dataAttr, urlParam) {
    const selected = selectedFromInputs(inputSelector, dataAttr);
    const inputs = document.querySelectorAll(inputSelector);
    if (inputs.length === 0) {
      return parseList(urlParam);
    }

    const knownValues = new Set(
      [...inputs].map((input) => input.dataset[dataAttr] || '').filter((value) => value !== ''),
    );

    parseList(urlParam).forEach((value) => {
      if (!knownValues.has(value) && !selected.includes(value)) {
        selected.push(value);
      }
    });

    return selected;
  }

  function selectedKinds() {
    return selectedWithUrlFallback('.ovs-panel-liner-kind-input', 'ovsPanelLinerKind', 'ovs_panel_liner_kind');
  }

  function selectedTypes() {
    return selectedWithUrlFallback('.ovs-panel-liner-type-input', 'ovsPanelLinerType', 'ovs_panel_liner_type');
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-panel-liner-kind-input').forEach((input) => {
      const label = input.closest('.ovs-panel-liner-kind-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('.ovs-panel-liner-type-input').forEach((input) => {
      const label = input.closest('.ovs-panel-liner-type-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncCheckboxesFromUrl() {
    const kinds = parseList('ovs_panel_liner_kind');
    const types = parseList('ovs_panel_liner_type');

    document.querySelectorAll('.ovs-panel-liner-kind-input').forEach((input) => {
      const kind = input.dataset.ovsPanelLinerKind || '';
      input.checked = kinds.includes(kind);
    });

    document.querySelectorAll('.ovs-panel-liner-type-input').forEach((input) => {
      const type = input.dataset.ovsPanelLinerType || '';
      input.checked = types.includes(type);
    });

    syncCheckboxLabels();
  }

  function buildUrl(kinds, types) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_panel_liner_kind');
    url.searchParams.delete('ovs_panel_liner_type');
    url.searchParams.delete('page');

    if (kinds.length > 0) {
      url.searchParams.set('ovs_panel_liner_kind', kinds.join(','));
    }

    if (types.length > 0) {
      url.searchParams.set('ovs_panel_liner_type', types.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(kinds, types) {
    if (!pagination) {
      return;
    }

    pagination.hidden = kinds.length > 0 || types.length > 0;
  }

  function applyFilters(updateHistory) {
    const kinds = selectedKinds();
    const types = selectedTypes();
    let visibleCount = 0;

    items.forEach((item) => {
      const itemKind = item.dataset.ovsPanelLinerKind || '';
      const itemType = item.dataset.ovsPanelLinerType || '';
      let show = true;

      if (kinds.length > 0) {
        show = itemKind !== '' && kinds.includes(itemKind);
      }

      if (show && types.length > 0) {
        show = itemType !== '' && types.includes(itemType);
      }

      item.hidden = !show;
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(kinds, types);

    if (updateHistory) {
      const url = buildUrl(kinds, types);
      window.history.pushState({ ovsPanelLinerFilters: true }, '', url.pathname + url.search);
    }
  }

  document.querySelectorAll('.ovs-panel-liner-kind-input, .ovs-panel-liner-type-input').forEach((input) => {
    input.addEventListener('change', () => {
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
